import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function PricingSection() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const handleCheckout = () => {
    trackAddToCart();
    window.location.href = 'https://pay.hotmart.com/F104677231J?checkoutMode=10';
  };
  return <section id="checkout" className="py-20 px-4 sm:px-6 bg-white relative" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-bg rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-brand-primary/20 text-center relative overflow-hidden" data-id="element-122">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-primary" data-id="element-123"></div>

          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-6" data-id="element-124">
            Compra tu libertad nocturna hoy mismo
          </h2>

          <p className="text-xl text-brand-text/80 mb-8 max-w-2xl mx-auto" data-id="element-125">
            Consigue el sistema completo "Cero Estrés 2-2-2" y elimina el "qué
            cocino hoy" de tu vocabulario para siempre.
          </p>

          {/* Product Image */}
          <div className="mb-8 flex justify-center" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/ftpc1nmS9TA4BMAL3d4hso/cover.png" alt="Ebook Cero Estrés 2-2-2" className="w-64 md:w-80 rounded-xl shadow-lg" data-id="element-127" />
          </div>

          <div className="bg-white rounded-2xl p-8 mb-8 inline-block w-full max-w-md shadow-sm border border-brand-light" data-id="element-128">
            <div className="flex justify-center items-center gap-3 mb-2" data-id="element-129">
              <span className="text-gray-400 line-through text-2xl font-bold" data-id="element-130">
                $59.99
              </span>
              <span className="bg-green-100 text-green-800 text-sm font-bold px-3 py-1 rounded-full" data-id="element-131">
                Descuento $40
              </span>
            </div>

            <div className="text-brand-text mb-2" data-id="element-132">Inversión única:</div>
            <div className="text-6xl font-bold text-brand-primary mb-4" data-id="element-133">
              $11.99 <span className="text-2xl text-brand-text/60" data-id="element-134">USD</span>
            </div>

            <p className="text-sm text-brand-text/60 italic" data-id="element-135">
              (Menos de lo que cuesta una sola cena a domicilio)
            </p>
          </div>

          <Button size="xl" animate fullWidth onClick={handleCheckout} className="max-w-md mx-auto text-lg md:text-xl shadow-[0_0_20px_rgba(232,115,74,0.4)]" data-id="element-136">
            ¡SÍ, QUIERO COCINAR EN 2 HORAS!
          </Button>

          <div className="mt-6 flex flex-col items-center gap-2 text-sm text-brand-text/60 font-medium" data-id="element-137">
            <p data-id="element-138">Acceso instantáneo a la guía y planificadores.</p>
            <div className="flex items-center gap-4 mt-2 opacity-70" data-id="element-139">
              <span data-id="element-140">🔒 Pago 100% Seguro</span>
              <span data-id="element-141">⚡ Acceso Inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}